import './styles/AgentProcessSelectionStyle.css';
import React, { useEffect, useState } from 'react';
import {
  MenuButton,
  NavigationButton,
  ToastType,
  TopNav,
  TopNavToastMessage,
} from '../common';
import { languageMap } from '../../maps/languageMap';
import { useActions, useTypedSelector } from '../../hooks';
import {
  APIResponseStatusType,
  MenuButtonType,
  navigationPages,
} from '../../models/types';
import { useHistory } from 'react-router-dom';
import Insert from '../../resources/images/insertion.png';
import Retrieve from '../../resources/images/removal.png';
import Deliver from '../../resources/images/manualDelivery.png';
import Fix from '../../resources/images/FixIcon.png';
import { LockerPosition, PackageCandidate } from '../../models/microservices';
import Spinner from 'react-bootstrap/Spinner';
import {
  LockerContentRequestGET,
  LockerContentResponseGET,
} from '../../models/cruds';
import { apiErrorHandler, apiGET } from '../../restApi';

const VALIDATION_ERROR = 'Error en la consulta';
const GET_LOCKER_RACK_CONTENT_EMPTY = 'No hay piezas en el Locker';
const PACKAGE_CODE_MI = 'MI';
const PACKAGE_CODE_EP = 'EP';
const PACKAGE_CODE_ET = 'ET';

const AgentProcessSelection: React.FC = () => {
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const language = useTypedSelector(({ session }) => {
    return session.language;
  });
  const token = useTypedSelector(({ session }) => {
    return session.dhlApiToken;
  });
  const lockerContent = useTypedSelector(({ locker }) => {
    return locker.lockerContent;
  });
  const {
    updateIsAgentProcess,
    updateCurrentLockerPosition,
    updateCurrentPackageCandidate,
  } = useActions();

  const { updateLockerContent, updateLockerRackId, updateRemoveLockerList } =
    useActions();
  useEffect(() => {
    const getlockerContent = async (): Promise<boolean> => {
      setLoading(true);
      let request = new LockerContentRequestGET();
      let response: LockerContentResponseGET = await apiGET(
        request.buildURL(),
        request.generateConfig(token)
      );
      let errorMsg = '';
      try {
        if (response.status === APIResponseStatusType.SUCCESS) {
          if (response.data.lockerRack) {
            let content = response.data.lockerRack;
            if (
              content.lockerPositions &&
              content.lockerPositions.length !== 0
            ) {
              updateLockerRackId(response.data.lockerRack.id);
              updateLockerContent(content.lockerPositions);
              let expiredPieces = content.lockerPositions.filter((position) => {
                if (
                  position.packageCandidate?.lastPackageStatus.code ===
                    PACKAGE_CODE_MI ||
                  position.packageCandidate?.lastPackageStatus.code ===
                    PACKAGE_CODE_EP ||
                  position.packageCandidate?.lastPackageStatus.code ===
                    PACKAGE_CODE_ET
                ) {
                  return position;
                }
                return null;
              });
              updateRemoveLockerList(expiredPieces);
              setLoading(false);
              return true;
            } else {
              setFeedbackMessage(GET_LOCKER_RACK_CONTENT_EMPTY);
              setLoading(false);
              return false;
            }
          } else {
            //TODO check for unauth and refresh token
            errorMsg = 'Unauthorized';
          }
        } else {
          errorMsg = apiErrorHandler(response);
        }
      } catch (err: any) {
        errorMsg = err.toString();
      }
      console.log(errorMsg);
      setFeedbackMessage(VALIDATION_ERROR);
      setLoading(false);
      return false;
    };
    getlockerContent();
  }, [token, updateLockerContent, updateRemoveLockerList]);
  useEffect(() => {
    updateIsAgentProcess(true);
    updateCurrentLockerPosition({} as LockerPosition);
    updateCurrentPackageCandidate({} as PackageCandidate);
  }, [
    updateIsAgentProcess,
    updateCurrentLockerPosition,
    updateCurrentPackageCandidate,
  ]);
  const insertButton = {
    key: 'insert',
    title: languageMap.agent_process_selection.insert[language],
    content: Insert,
    action: () => history.replace(`/${navigationPages.INSERT_SCAN_PID}`),
  };
  const retrieveButton = {
    key: 'retrieve',
    title: languageMap.agent_process_selection.retrieve[language],
    content: Retrieve,
    action: () => removePieces(),
  };
  const deliverButton = {
    key: 'deliver',
    title: languageMap.agent_process_selection.deliver[language],
    content: Deliver,
    action: () =>
      history.replace(`/${navigationPages.CLIENT_RETRIEVAL_SCAN_AWB}`),
  };
  const fixButton = {
    key: 'fix',
    title: languageMap.agent_process_selection.compartments[language],
    content: Fix,
    action: () => history.replace(`/${navigationPages.AGENT_LOCKER_FIX}`),
  };
  const buttonList: MenuButtonType[] = [
    insertButton,
    retrieveButton,
    deliverButton,
    fixButton,
  ];
  const removePieces = () => {
    if (lockerContent.length > 0) {
      history.replace(`/${navigationPages.REMOVE_PROCESS_SELECTION}`);
    } else {
      setFeedbackMessage(GET_LOCKER_RACK_CONTENT_EMPTY);
    }
    return;
  };
  const renderContent = () => {
    if (loading) {
      return (
        <div className="employee-number-numpad-container">
          <div className="spinner-container">
            <Spinner className="spinner" animation="grow" variant="danger" />
          </div>
        </div>
      );
    }
    return (
      <div className="agent-process-button-container">
        {buttonList.map((button: MenuButtonType) => {
          return (
            <MenuButton
              key={button.key}
              buttonTitle={button.title}
              buttonContent={button.content}
              onClickButton={() => {
                if (button.action && typeof button.action === 'function') {
                  button.action();
                }
              }}
            />
          );
        })}
      </div>
    );
  };
  return (
    <div id="clientRetrievalIssues" className="main-container">
      <TopNav dataCyPrefix="scan-awb" />
      <div className="content-container">
        <div className="main-content-container fullpage">
          <TopNavToastMessage
            toastText={feedbackMessage}
            toastType={ToastType.ERROR}
            resetMessage={() => setFeedbackMessage('')}
          />
          <div className="title-content-container">
            <p className="header nopadding nomargin">
              {languageMap.agent_process_selection.title[language]}
            </p>
          </div>
          <div className="data-content-container">{renderContent()}</div>
          <div className="footer-container">
            <div className="footer-button-container">
              <NavigationButton
                buttonContent={
                  languageMap.agent_process_selection.cancel_button[language]
                }
                buttonClass="navigation-button cancel-button"
                onClickButton={() => {
                  history.replace(`/${navigationPages.THANK_YOU}`);
                }}
              />
            </div>
            <div className="footer-button-container" />
          </div>
        </div>
      </div>
    </div>
  );
};

export { AgentProcessSelection };
